import { FiMenu } from 'react-icons/fi';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const AdminNav = ({ openSidebar, side, closeSidebar }) => {
  const [name, setName] = useState('Admin');
  const [photo, setPhoto] = useState(null);

  useEffect(() => {
    const storedAdminData = localStorage.getItem('userData');
    if (storedAdminData) {
      const admin = JSON.parse(storedAdminData);
      setName(admin?.name || 'Admin');
      setPhoto(admin?.photo);
    }
  }, []);

  return (
    <nav
      className={`fixed z-30 top-0 right-0 bg-white shadow-md py-3 px-4 w-full transition-all duration-300 ${
        side === 'left-0 md:-left-72' ? 'left-0' : 'left-0 md:left-72'
      }`}
    >
      <div className="flex justify-between items-center">
        {/* Menu icon (mobile only) */}
        <div className="flex items-center gap-4">
          <div className="block md:hidden">
            <FiMenu
              size={26}
              onClick={side === 'left-0 md:-left-64' ? closeSidebar : openSidebar}
              className="cursor-pointer text-gray-700 hover:text-blue-600"
            />
          </div>
          <h2 className="text-xl font-semibold text-[#002D42]">Super Admin Dashboard</h2>
        </div>

        {/* Admin Info */}
        <div className="flex items-center gap-4">
          {photo ? (
            <img
              src={photo}
              alt="Admin"
              className="w-10 h-10 rounded-full object-cover border-2 border-blue-500"
            />
          ) : (
            <div className="w-10 h-10 bg-blue-200 rounded-full flex items-center justify-center font-bold text-blue-800">
              {name?.charAt(0)?.toUpperCase()}
            </div>
          )}
          <p className="text-gray-800 font-medium">{name}</p>
        </div>
      </div>
    </nav>
  );
};

export default AdminNav;
